import React, { Component } from "react";
import { withRouter } from "next/router";
import { inject, observer } from "mobx-react";
import { BonusCardModel } from "../../../components/bonusPage/bonusCard/model";
import ProfileNavigationBar from "../../../components/profileNavBar";
import styles from "./detailBonusPage.module.scss";
import { getDaysLeft, isPastDate, sendMetrics } from "../../../utils/misc";
import Spinner from "../../../components/spinner";
import BonusesEndedState from "../../../components/bonusPage/detailBonusStates/bonusesEndedState";
import BonusesOpened from "../../../components/bonusPage/detailBonusStates/bonusesOpened";
import BonusesCanTake from "../../../components/bonusPage/detailBonusStates/bonusesCanTake";
import BonusesNeedAuthorization from "../../../components/bonusPage/detailBonusStates/bonusesNeedAuthorization";
import BonusesNeedDonation from "../../../components/bonusPage/detailBonusStates/bonusesNeedDonation";
import redirectTo from "../../../utils/redirectTo";
import { cityIn } from "lvovich";
import BonusStub from "../../../components/bonusStub/bonusStub";
import BonusesExpired from "../../../components/bonusPage/detailBonusStates/bonusesExpired";
import Link from "next/link";

@withRouter
@inject("bonusStore")
@inject("uiStore")
@inject("authStore")
@observer
class DetailBonusPage extends Component<any, any> {
  state: {
    bonus: BonusCardModel;
    errorText: string;
  };
  private readonly id: number;

  constructor(props) {
    super(props);
    this.state = {
      bonus: {},
      errorText: "",
    };
    this.id = this.props.router.query.id;
  }

  updateDetail = () => {
    this.props.bonusStore
      .loadDetailBonus(this.id)
      .then((bonus) => {
        this.setState({
          bonus: new BonusCardModel(bonus),
        });
      })
      .catch(async (res) => {
        if (res.response?.status === 403) {
          const data = await res.response.data.detail;
          this.setState({
            errorText: data,
          });
        } else {
          redirectTo("/profile/bonus/");
        }
      });
  };

  componentDidMount() {
    this.props.uiStore.setActiveTab(1);
    if (this?.id) {
      this.updateDetail();
    }
  }

  getPromo = () => {
    if (this.id) {
      sendMetrics("get_promocode");
      this.props.bonusStore
        .takeBonusByIdToUser({
          bonus_id: this.id,
        })
        .then((resp) => {
          this.updateDetail();
        })
        .catch((resp) => {
          this.setState({
            bonus: new BonusCardModel({
              ...this.state.bonus.rawBonusCard,
              state: 5,
            }),
          });
        });
    }
  };

  back = () => {
    if (typeof window !== "undefined") {
      const prevPath = window.sessionStorage.getItem("prevPath");
      if (prevPath !== "null" && prevPath) redirectTo(prevPath);
      else redirectTo("/bonus/");
    } else redirectTo("/bonus/");
  };

  getBonusActivityByState = (bonus: BonusCardModel): JSX.Element => {
    if (bonus.isExpired && !bonus.isTaken) {
      return <BonusesExpired />
    }

    if (bonus.stateName?.length && !bonus.isAvailable && (bonus.id === 249 || bonus.id === 230)) {
      return <BonusesNeedDonation id={bonus.id} />;
    }

    if (bonus.stateName?.length) {
      switch (bonus.stateName) {
        case "UnAuthorized":
          return <BonusesNeedAuthorization />;
        case "NoDonations":
          return <BonusesNeedDonation />;
        case "CanTake":
          return <BonusesCanTake getPromo={this.getPromo} />;
        case "AlreadyTaken":
          return <BonusesOpened info={bonus} />;
        case "BonusesEnded":
          return <BonusesEndedState />;
        default:
          return <BonusesEndedState />;
      }
    } else {
      return <Spinner toggled={true} onAll={true} onEmptyPage={true} />;
    }
  };

  getCities = () => {
    const loadCities = this.state.bonus.cities;
    return loadCities?.map((city) => cityIn(city.title)).join(", ");
  };

  render() {
    const { user } = this.props.authStore;
    const { bonus, errorText } = this.state;
    const cities = this.getCities();

    // if (errorText) {
    //   return (
    //     <div className={styles.DetailBonusPageContent}>
    //       <div className="container">
    //         <BonusStub textContent={errorText} />
    //       </div>
    //     </div>
    //   );
    // }

    return (
      <div className={styles.DetailBonusPage}>
        {user && <ProfileNavigationBar />}
        <div className={"container"}>
          <div className={styles.DetailBonusPageContent}>
            {(!user || bonus.stateName === 'NoDonations') && <BonusStub textContent={errorText} />}
            <span
              onClick={this.back}
              className={styles.DetailBonusPageContentBack}
            >
              <img src="/static/images/arrows/backProfile.svg" alt="" />
              Назад
            </span>
            <div className={styles.DetailBonusPageContentBlock}>
              <div className={styles.DetailBonusPageContentBlockLeft}>
                <div
                  className={styles.DetailBonusPageContentBlockLeftContainer}
                >
                  <div
                    className={styles.DetailBonusPageContentBlockLeftMain}
                    style={{
                      backgroundImage: `radial-gradient(circle, rgba(193,196,202,0) 0%, rgba(95,97,119,1) 100%), url(${bonus.bonusImageFull})`,
                      filter: `${bonus.isExpired ? 'grayscale(100%)' : 'grayscale(0%)'}`
                    }}
                  >
                    <div
                      className={styles.DetailBonusPageContentBlockLeftMainTop}
                    >
                      <div
                        className={
                          styles.DetailBonusPageContentBlockLeftMainTopName
                        }
                      >
                        {bonus.bonusName}
                      </div>
                      <div
                        className={
                          styles.DetailBonusPageContentBlockLeftMainTopLogo
                        }
                      >
                        <div
                          style={{
                            backgroundImage: `url(${bonus.partnerImage})`,
                          }}
                        ></div>
                      </div>
                    </div>
                    {cities && (
                      <div
                        className={
                          styles.DetailBonusPageContentBlockLeftMainMiddle
                        }
                      >
                        Действует в {cities}
                      </div>
                    )}
                    <div
                      className={styles.DetailBonusPageContentBlockLeftMainBot}
                    >
                      <div
                        className={
                          styles.DetailBonusPageContentBlockLeftMainBotDate
                        }
                      >
                        <span>{bonus.dateValidityBeautify} </span>
                        {
                          isPastDate(bonus.dateValidity!) &&
                          <span>({getDaysLeft(bonus.dateValidity!)})</span>
                        }
                      </div>
                      <div
                        className={
                          styles.DetailBonusPageContentBlockLeftMainBotPName
                        }
                      >
                        {bonus.partnerName}
                      </div>
                    </div>
                  </div>
                  <div className={styles.DetailBonusPageContentBlockLeftSecond}>
                    {this.getBonusActivityByState(this.state.bonus)}
                    {this.state.bonus.isTaken && <Link href={`./${this.id}/feedback`}>{this.state.bonus.hasFeedback ? "Мой отзыв" : "Оставить отзыв"}</Link>}
                  </div>
                </div>
                <div
                  className={styles.DetailBonusPageContentBlockLeftDesc}
                  dangerouslySetInnerHTML={{
                    __html: `${bonus.bonusDescription}`,
                  }}
                ></div>
                <div className={styles.DetailBonusPageContentBlockLeftUrl}>
                  <div onClick={() => sendMetrics("to_bonus_partner")}>
                    <img
                      src="/static/images/icons/bonusPartnerLink.svg"
                      alt=""
                    />
                    <a target={"_blank"} href={bonus.partnerUrl}>
                      Сайт партнера
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DetailBonusPage);
